import { Box, Typography } from '@mui/material';
import Card from './Card';
import React, { ReactNode } from 'react';

export type SelectOption = {
  // Key
  name: string;

  // Display
  label: ReactNode;

  selected: boolean;
};

export type MultiSelectProps = {
  options: SelectOption[];
  onSelect: (options: SelectOption[]) => any;
  error?: string | string[];
  label?: ReactNode;
};

export function getSelectedNames(options: SelectOption[]): string[] {
  return options
    .filter((option) => option.selected)
    .map((option) => option.name);
}

export default function MultiSelect({
  options,
  onSelect,
  label,
  error,
}: MultiSelectProps) {
  const handleClick = (oldOption: SelectOption) => {
    // Update `selected` for options
    const newOptions = options.map((option) => {
      if (option.name === oldOption.name) {
        return { ...option, selected: !option.selected };
      }
      return option;
    });

    onSelect(newOptions);
  };

  return (
    <Box>
      {label && (
        <Typography variant="subtitle1" sx={{ marginBottom: '6px' }}>
          {label}
        </Typography>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {options.map((option) => (
          <Card
            key={option.name}
            onClick={() => handleClick(option)}
            sx={{
              backgroundColor: option.selected ? 'primary.main' : 'white',
              padding: '8px 12px',
              width: `${100 / options.length - 1}%`,
            }}
          >
            <Typography
              sx={{
                color: option.selected ? 'white' : 'primary.dark',
                fontSize: '10px',
                textAlign: 'center',
              }}
            >
              {option.label}
            </Typography>
          </Card>
        ))}
      </Box>

      {error && (
        <Box>
          <Typography sx={{ color: 'error.main' }}>{error}</Typography>
        </Box>
      )}
    </Box>
  );
}
